import React from 'react'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { Box, Grid, Button, useMediaQuery } from '@material-ui/core'
import { PATHS, PROVIDER_NAME } from '~/common/constants'
import { WelcomeLayout } from '~/components/layout'
import { useHistory } from 'react-router-dom'
import { ReactComponent as AppleSvg } from './icons-social/apple-icon.svg'
import { ReactComponent as GoogleSvg } from './icons-social/google-icon.svg'
import { ReactComponent as FacebookSvg } from './icons-social/facebook-icon.svg'
import { ReactComponent as LinkedInSvg } from './icons-social/linkedin-icon.svg'
import { gridCotainerStyle, h4Text, proceedStyle, signinBtnStyle, signupBtnStyle } from './common-authorization.style'
import { Typography } from '~/components/typography'
import { fireStore, routerStore } from '~/stores'
import { commonSigninStore } from './common-authorization.store'
import { useLinkedIn } from 'react-linkedin-login-oauth2'
import { handleLoadReCaptcha } from '~/common/helpers'

export const CommonVerifyAccountFeature = () => {
	const { t } = useTranslation()
	const history = useHistory()
	const [isHandlingSuccess, setIsHandlingSuccess] = React.useState(false)

	const { linkedInLogin } = useLinkedIn({
		clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
		redirectUri: `${window.location.origin}/linkedin`,
		onSuccess: (data) => {
			if (!isHandlingSuccess) {
				setIsHandlingSuccess(true)
				commonSigninStore.handleSuccess(data, history)
			}
		},
		scope: 'openid profile email',
		onError: (error) => {
			setIsHandlingSuccess(false)
			console.log('🚀 ~ file: common-authorization.feature.js:34 ~ CommonVerifyAccountFeature ~ error:', error)
		},
	})

	const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down('xs'))

	return (
		<WelcomeLayout sizeLogo={isXsScreen ? 255 : 360}>
			<Grid container={true} css={gridCotainerStyle}>
				<Grid item={true} xs={12}>
					<Box display="flex" alignItems="center" flexDirection="column" gridGap="8px">
						<Typography css={h4Text} align="center" color="textSecondary">
							{t('$MESSAGES.WELCOME_GHR')}
						</Typography>
					</Box>
				</Grid>

				<Grid item={true} xs={12}>
					<Box display="flex" alignItems="center" flexDirection="column" gridGap="1rem" width={isXsScreen ? '280px' : '360px'} margin="auto" maxWidth="100%">
						<Button css={signupBtnStyle} fullWidth={true} variant="contained" color="primary" onClick={() => routerStore.goPage(PATHS.common.signup)}>
							<Typography>{t('CREATE_A_NEW_ACCOUNT')}</Typography>
						</Button>
						<Button css={signinBtnStyle} fullWidth={true} variant="outlined" color="primary" onClick={() => routerStore.goPage(PATHS.common.signin)}>
							<Typography> {t('LOGIN')}</Typography>
						</Button>
					</Box>
					<Grid item={true} xs={12}>
						<Box mt={2} display="flex" alignItems="center" flexDirection="column" gridGap="8px">
							<Typography
								onClick={async () => {
									await (window.location.href = PATHS.care.search)
								}}
								align="center"
								style={{ textDecoration: 'auto', cursor: 'pointer' }}
								css={proceedStyle}
							>
								{t('CONTINUE_AS_GUEST')}
							</Typography>
						</Box>
					</Grid>
				</Grid>
				<Grid item={true} xs={12}>
					<Box display="flex" alignItems="center" flexDirection="column" gridGap="1rem">
						<Typography css={h4Text} align="center">
							{t('OR_CONTINUE_WITH')}
						</Typography>
						<Box width="264px" margin="auto" maxWidth="100%" display="flex" gridGap="1rem" alignItems="center">
							<AppleSvg
								style={{ cursor: 'pointer', marginLeft: '2px', marginRight: '2px' }}
								onClick={() => {
									handleLoadReCaptcha()
									fireStore.signInWithFirebase(history, PROVIDER_NAME.apple)
								}}
							/>
							<GoogleSvg
								style={{ cursor: 'pointer', marginLeft: '2px', marginRight: '2px' }}
								onClick={() => {
									handleLoadReCaptcha()
									fireStore.signInWithFirebase(history, PROVIDER_NAME.google)
								}}
							/>
							<FacebookSvg
								style={{ cursor: 'pointer', marginLeft: '2px', marginRight: '2px' }}
								onClick={() => {
									handleLoadReCaptcha()
									fireStore.signInWithFirebase(history, PROVIDER_NAME.facebook)
								}}
							/>
							<LinkedInSvg
								style={{ cursor: 'pointer', marginLeft: '2px', marginRight: '2px' }}
								onClick={async () => {
									await setIsHandlingSuccess(false)
									await handleLoadReCaptcha()
									await linkedInLogin()
								}}
							/>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</WelcomeLayout>
	)
}
